var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _rect, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _rect2, _rect3, _rect4, _rect5, _rect6, _path29, _path30, _rect7, _rect8, _path31, _path32, _path33, _rect9, _rect10, _rect11, _rect12, _path34, _path35, _rect13, _rect14, _path36, _path37, _path38, _path39, _rect15, _path40, _rect16, _path41, _rect17, _rect18, _rect19, _rect20, _rect21, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGeneric3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 588.82 287.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e7f3fd;}.cls-2{fill:#a5daee;}.cls-3{fill:#97d0e0;}.cls-4{fill:#2f5c9b;}.cls-5{fill:#f19a5a;}.cls-6{fill:#e38540;}.cls-7{fill:#77a0d5;}.cls-8{fill:#a86b49;}.cls-9{fill:#3f6cac;}.cls-10{fill:#f1cfb4;}.cls-11{fill:#abcced;}.cls-12{fill:#f6a970;}.cls-13{fill:#b9e0f8;}.cls-14{fill:#fff;}.cls-15{fill:#a3c5e9;}.cls-16{fill:#9ecd98;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "IMG-3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.78,440.23s-49.33-61.16-19.73-119.37,85.83-44.39,164.75-103.58c95.81-71.86,163.08-75.81,248.6-44.4,48.34,17.76,56.23,90.76,133.18,136.14C631,349.93,574.4,419.51,537.9,430.37s-61.16,10.85-61.16,10.85Z",
    transform: "translate(-5.59 -154.18)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M328.45,308.73c-12.31,25-27.75,93.29-32,97S268,424,263.75,431s-2.34,4.67-.47,5.14,107.58.94,107.58.94-12.16-72.5-13.56-73S328.45,308.73,328.45,308.73Z",
    transform: "translate(-5.59 -154.18)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M310.94,436.76c19.42.13,39.9.24,51.18.3l-15.44-92.35c-8.23-16-18.23-36-18.23-36-1.55,3.15-3.16,7-4.78,11.3-1.6,69.36,8.39,88.8.89,101.16C318.7,430.84,313.36,435.15,310.94,436.76Z",
    transform: "translate(-5.59 -154.18)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M530.43,441.72H22.82a3.92,3.92,0,1,1,0-7.83H530.43a3.92,3.92,0,1,1,0,7.83Z",
    transform: "translate(-5.59 -154.18)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M393.28,278.57c17.55,16.21,56.64,31.58,56.64,31.58s5.93,54.86,1.88,85.92-1.8,37.37-1.8,37.37H369.42s-10.82-15-30.62-61.68c-12.6-29.71-10.35-63-10.35-63l49.07-22.06Z",
    transform: "translate(-5.59 -154.18)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M369.42,433.44H450s-2.25-6.3,1.8-37.37c3.34-25.58-.1-67.29-1.42-81.22l-7.32-3.15c-18.4,5.31-29,32.75-32.12,59.57-2.09,17.94-31.82,35.61-51.27,45.33C366.06,428.78,369.42,433.44,369.42,433.44Z",
    transform: "translate(-5.59 -154.18)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M349.66,222.26c-9.71,21.63,1.94,41.67,1.59,40.83S366,226.56,366,226.56Z",
    transform: "translate(-5.59 -154.18)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M386.47,238.26l12.32,45a4.06,4.06,0,0,1-.78,3.64c-2.89,3.56-7,10.89-15.3,13.23a20.63,20.63,0,0,1-5.21.59A3.53,3.53,0,0,1,374,297.9l-8.25-42.71Z",
    transform: "translate(-5.59 -154.18)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M384.12,242l-4.5,1.85-13.85,11.32,7.43,37.87C385.8,285.2,387.64,279.9,384.12,242Z",
    transform: "translate(-5.59 -154.18)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M386,258.18C383.29,273,372.21,283,361.26,280.55s-16.17-12-14.88-31.26c1-15.09,8.44-31.48,19.39-29S388.74,243.36,386,258.18Z",
    transform: "translate(-5.59 -154.18)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M449.92,310.15c16.3,3.68,19.33,36.79,24.63,71.72.61,4,3.74,38.05,3.74,38.05a10.39,10.39,0,0,1-5.92,9.35c-5.33,2.67-7.48,4.68-38.36,5-29.65.3-67.88-.93-67.88-.93s-.34-11,2.71-16.43c4.57-8.11,51.45-19.75,55.82-20.37.62-8.73-4.31-40.33,2.49-61.75,4.68-14.73,9.71-22.45,16-24.47A12.64,12.64,0,0,1,449.92,310.15Z",
    transform: "translate(-5.59 -154.18)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M382.9,434c14.62.22,34.68.43,51.11.26,30.88-.31,33-2.32,38.36-5,6.24-3.12,6.55-8.42,6.55-8.42s-3.15-36.2-3.74-40.23c-3.43-23.39-7.14-50.15-15.77-63.07A176.15,176.15,0,0,1,469,369.94c.08,4.34-.32,10.28-1.59,14.43-1.4,4.59-5,7.48-10.6,5.92-11.23-3.12-25.26,3.43-25.26,3.43s10.6-3.74,20.58-.31,30.56,26.19,8.11,34.61C453.34,430.6,412.18,432.7,382.9,434Z",
    transform: "translate(-5.59 -154.18)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M371.33,417.94s4.16-7.07,12.68-7.07,7.9,13.93,6.66,18.51-6.24,4.78-6.24,4.78l-18.3-.83Z",
    transform: "translate(-5.59 -154.18)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 228.7,
    y: 275.92,
    width: 121.66,
    height: 7.23,
    rx: 3.16
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M369,418.77c-17.88-6.44-22.57-4-26.61-5.19-10-2.92-12.47-.42-18.92,17.25-1.28,3.52,2.5,3.74,6.24,3.74s8.32-7.27,9.77-8.11,5.41-1.24,5.41-1.24-1.25,0-3.12,3.74-4.16,5.2-1.25,5.2,3.33-4.78,8.73-3.75,3.33,3.75,16.84,3.54,23.71,0,23.5-8.11c-.21-7.69.64-11.54-6.66-12.89C377.36,411.91,369,418.77,369,418.77Z",
    transform: "translate(-5.59 -154.18)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M369.28,418.77c12-1.35,8.44,13.54,7.2,14.79s6.65.44,6.65.44a14.44,14.44,0,0,0,.6-12.84,11.66,11.66,0,0,0-9.36-7.17l-5.3,2.91Z",
    transform: "translate(-5.59 -154.18)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M381.76,417.48c-.16,1.84-3.29,3.09-7,2.78s-6.6-2.06-6.44-3.91,3.29-3.09,7-2.78S381.91,415.63,381.76,417.48Z",
    transform: "translate(-5.59 -154.18)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M380.81,416.56c-.14,1.65-2.94,2.76-6.26,2.48s-5.9-1.84-5.76-3.49,2.94-2.76,6.26-2.48S381,414.91,380.81,416.56Z",
    transform: "translate(-5.59 -154.18)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M378.74,415.79c-.1,1.19-2.12,2-4.51,1.79s-4.24-1.32-4.15-2.51,2.12-2,4.51-1.79S378.83,414.61,378.74,415.79Z",
    transform: "translate(-5.59 -154.18)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M233.23,414.49H117.05A12.73,12.73,0,0,1,104.59,404L89.44,320.32a12.8,12.8,0,0,1,12.46-15.16H218.08a12.73,12.73,0,0,1,12.46,10.52l15.15,83.65A12.79,12.79,0,0,1,233.23,414.49Z",
    transform: "translate(-5.59 -154.18)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M238.66,399.64,223.2,317.73a12.84,12.84,0,0,0-12.72-10.3H92.41a13,13,0,0,0-3,10.92l15.68,85.4A13.12,13.12,0,0,0,118,414.49H226A12.68,12.68,0,0,0,238.66,399.64Z",
    transform: "translate(-5.59 -154.18)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M210.65,425.69H188.59c-3.93,0-7.12-3.51-7.12-7.83V377.54c0-6.88-5.08-12.46-11.34-12.46H158.61c-6.26,0-11.34,5.58-11.34,12.46V422.7c0,7.72,5.73,14,12.76,13.92l60.19-.42C220.22,430.4,215.93,425.69,210.65,425.69Z",
    transform: "translate(-5.59 -154.18)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M148.15,378.44v44.47a13.71,13.71,0,0,0,12.71,13.67l58.75-.37c0-1-4.64-2.71-10.36-2.71H185.39a7.71,7.71,0,0,1-7.7-7.71V378.44a12.26,12.26,0,0,0-12.27-12.26h-5A12.26,12.26,0,0,0,148.15,378.44Z",
    transform: "translate(-5.59 -154.18)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M271.11,420.56c8.88-4.93,19.73-3.29,23.68,1.65s4.6,8.22-4.28,8.22-26.63.65-29.59.33S271.11,420.56,271.11,420.56Z",
    transform: "translate(-5.59 -154.18)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M284.27,417.6c9.53-2.3,16.05,3.25,24,8.55,6.9,4.61,8.29,9.08.66,5.26-11.18-5.59-17.76-6.24-17.76-6.24Z",
    transform: "translate(-5.59 -154.18)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M275.58,420.53c-4.81,0-9-1.53-12.42-1.25S249,430.61,250.7,431.46a3,3,0,0,0,.4.17,5.8,5.8,0,0,0,6.88-2.41c1.52-2.45,4-5.29,6.88-4.27a30.85,30.85,0,0,0,9.87,1.53Z",
    transform: "translate(-5.59 -154.18)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M272.76,432.4c-4.93-2,3-18.41,5.59-18.41s12.49,7.89,12.49,7.89-2.32,1.31-10.19-1.32c-2-.66-3.62,10.52-5.92,11.84S272.76,432.4,272.76,432.4Z",
    transform: "translate(-5.59 -154.18)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M346.37,257.94c-.46,18.11,5.71,21.17,10,23.63s22.9-1.61,25.63-6.08c7-11.46,1.11-22.14,2.67-22s3,4.62,7.06,10.41c.38.54,3,4.12,3.16,2.93,1.89-16.22,10.33-21.25,8.32-37.65-1.48-12.08-9.15-11.12-9.15-11.12s-4.95-10.12-20.36-9c-10.33.77-19.53,4.79-30.17,7.53s12.59,26.86,26.39,18.05,7,10.6,9.17,12.1,1.05.2,2,10.14-11.61,16.41-15.23,17.26c-11.56,2.72-13.49.82-16-3.54C347.7,266.88,346.37,257.94,346.37,257.94Z",
    transform: "translate(-5.59 -154.18)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M394.22,252.34c-1.33,4.56-4.57,7.51-7.24,6.58s-2.75-4.63-2.44-9.94c.29-4.78,4.57-7.51,7.24-6.58S395.54,247.77,394.22,252.34Z",
    transform: "translate(-5.59 -154.18)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 35.37,
    y: 39.55,
    width: 102.58,
    height: 46.36,
    rx: 1.94
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 38.18,
    y: 51.73,
    width: 96.97,
    height: 32,
    rx: 1.57
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 39.6,
    y: 42.96,
    width: 4.02,
    height: 3.62,
    rx: 0.87
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 46.91,
    y: 42.96,
    width: 4.02,
    height: 3.62,
    rx: 0.87
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 54.22,
    y: 42.96,
    width: 4.02,
    height: 3.62,
    rx: 0.87
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M136.8,212.92H85.5a1.54,1.54,0,0,1,0-3.07h51.3a1.54,1.54,0,0,1,0,3.07Z",
    transform: "translate(-5.59 -154.18)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M98.22,236.6H46.92a1.54,1.54,0,0,1,0-3.07h51.3a1.54,1.54,0,0,1,0,3.07Z",
    transform: "translate(-5.59 -154.18)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 96.24,
    y: 79.35,
    width: 6.36,
    height: 3.07,
    rx: 0.52
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 104.24,
    y: 79.35,
    width: 6.36,
    height: 3.07,
    rx: 0.52
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M137.29,219.61H52.35a1,1,0,1,1,0-2.08h84.94a1,1,0,1,1,0,2.08Z",
    transform: "translate(-5.59 -154.18)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M137.29,224.1H52.35a1,1,0,0,1,0-2.08h84.94a1,1,0,1,1,0,2.08Z",
    transform: "translate(-5.59 -154.18)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M60.5,72.1h98.69A1.94,1.94,0,0,1,161.14,74v42.47a1.95,1.95,0,0,1-1.95,1.95H60.5a1.95,1.95,0,0,1-1.95-1.95V74A1.95,1.95,0,0,1,60.5,72.1Z"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 61.36,
    y: 84.28,
    width: 96.97,
    height: 32,
    rx: 1.57
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 62.78,
    y: 75.51,
    width: 4.02,
    height: 3.62,
    rx: 0.87
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 70.09,
    y: 75.51,
    width: 4.02,
    height: 3.62,
    rx: 0.87
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 77.4,
    y: 75.51,
    width: 4.02,
    height: 3.62,
    rx: 0.87
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M160,245.47h-51.3a1.54,1.54,0,0,1,0-3.07H160a1.54,1.54,0,0,1,0,3.07Z",
    transform: "translate(-5.59 -154.18)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M121.4,269.15H70.1a1.54,1.54,0,0,1,0-3.07h51.3a1.54,1.54,0,0,1,0,3.07Z",
    transform: "translate(-5.59 -154.18)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 119.42,
    y: 111.9,
    width: 6.36,
    height: 3.07,
    rx: 0.52
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 127.42,
    y: 111.9,
    width: 6.36,
    height: 3.07,
    rx: 0.52
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M160.47,252.16H75.53a1,1,0,0,1,0-2.08h84.94a1,1,0,1,1,0,2.08Z",
    transform: "translate(-5.59 -154.18)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M160.47,256.65H75.53a1,1,0,1,1,0-2.08h84.94a1,1,0,0,1,0,2.08Z",
    transform: "translate(-5.59 -154.18)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M203.22,261.3A13.32,13.32,0,1,1,189.91,248,13.31,13.31,0,0,1,203.22,261.3Z",
    transform: "translate(-5.59 -154.18)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M188.59,266.22h0a1,1,0,0,1-.72-.35l-3.62-4.11a1,1,0,1,1,1.52-1.34l2.91,3.31,7-6.82a1,1,0,0,1,1.44,0,1,1,0,0,1,0,1.43l-7.72,7.57A1.05,1.05,0,0,1,188.59,266.22Z",
    transform: "translate(-5.59 -154.18)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 194.34,
    y: 7.12,
    width: 92.56,
    height: 38.14,
    rx: 3.95
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M211.11,193.69v21l24.25-24.25S211.6,193.69,211.11,193.69Z",
    transform: "translate(-5.59 -154.18)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 199.12,
    y: 10.9,
    width: 82.98,
    height: 30.58,
    rx: 3.35
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M249.91,172.64H212.42a1.65,1.65,0,0,1,0-3.29h37.49a1.65,1.65,0,0,1,0,3.29Z",
    transform: "translate(-5.59 -154.18)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 205.19,
    y: 22.9,
    width: 71.35,
    height: 1.85,
    rx: 0.91
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 205.19,
    y: 26.48,
    width: 71.35,
    height: 1.85,
    rx: 0.91
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 258.11,
    y: 36.55,
    width: 4.02,
    height: 3.62,
    rx: 0.87
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 265.41,
    y: 36.55,
    width: 4.02,
    height: 3.62,
    rx: 0.87
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 272.72,
    y: 36.55,
    width: 4.02,
    height: 3.62,
    rx: 0.87
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M158,342.67c0,1.36,0,2.72,0,4.08,0,.22-.06.31-.27.34a7.56,7.56,0,0,1-2.64.08,1.6,1.6,0,0,1-1.34-1.77c0-1.54,0-3.07,0-4.61,0-1,0-2,0-3a1.92,1.92,0,0,1,.79-1.6,7.76,7.76,0,0,1,3.91-1.51,7.62,7.62,0,0,1,3.29.27,4.28,4.28,0,0,1,1.29.62.41.41,0,0,0,.55,0,6.94,6.94,0,0,1,5.76-.65,4,4,0,0,1,2.93,3.92c0,2.66,0,5.31,0,8,0,.14,0,.25-.18.28a6.89,6.89,0,0,1-2.86.06,1.44,1.44,0,0,1-1.15-1.26,5.55,5.55,0,0,1-.06-.82v-5.58a1.45,1.45,0,0,0-2-1.51l-.16.05c-.68.24-.69.25-.69,1q0,3.88,0,7.75c0,.23-.06.34-.31.38a9.38,9.38,0,0,1-2.31.11,1.64,1.64,0,0,1-1.63-1.88c0-1.85,0-3.7,0-5.55v-.56A1.19,1.19,0,0,0,160,338a2.26,2.26,0,0,0-1.83.23c-.17.09-.13.23-.13.37C158,340,158,341.31,158,342.67Z",
    transform: "translate(-5.59 -154.18)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M126.68,343.26c.14,0,.16-.06.18-.17.53-2.37,1.17-4.72,1.63-7.12a.53.53,0,0,1,.41-.46,5.13,5.13,0,0,1,3.24-.09,1.61,1.61,0,0,1,1.14,1.22c.54,2.17,1.19,4.3,1.7,6.47a.23.23,0,0,0,.1.16c.12,0,.08-.12.09-.18.32-2,.56-4.1.79-6.15.15-1.43.33-2.85.48-4.28a.46.46,0,0,1,.32-.43,3.77,3.77,0,0,1,2.89-.15,1.42,1.42,0,0,1,1.07,1.53,23.7,23.7,0,0,1-.33,3.25,70.6,70.6,0,0,1-1.49,7.64c-.15.54-.32,1.06-.49,1.59a1.07,1.07,0,0,1-.65.68,6.49,6.49,0,0,1-3.17.45,4.22,4.22,0,0,1-1.6-.42,1.41,1.41,0,0,1-.72-.85c-.51-1.6-.92-3.22-1.35-4.83l-.11-.4c-.19.85-.37,1.62-.55,2.38-.25,1-.52,2-.77,3.07a.75.75,0,0,1-.39.52,4.68,4.68,0,0,1-2,.54,6.08,6.08,0,0,1-2.67-.33,1.92,1.92,0,0,1-1.22-1.22,39.47,39.47,0,0,1-1.22-4.54,9.93,9.93,0,0,1-.27-1.34h.07v.07l.06.06.46.72.07.07a6.48,6.48,0,0,0,2.19,1.84A5.46,5.46,0,0,0,126.68,343.26Z",
    transform: "translate(-5.59 -154.18)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M178.1,333.46c0,.42,0,.83,0,1.25,0,.24.05.3.3.21a6.16,6.16,0,0,1,3.82-.11,5.58,5.58,0,0,1,4.11,4.61,8,8,0,0,1-.17,3.88,5.11,5.11,0,0,1-3.41,3.63,8.87,8.87,0,0,1-7.13-.42,7.71,7.71,0,0,1-.77-.49,2.29,2.29,0,0,1-1-2c0-4.31,0-8.63,0-12.94a.3.3,0,0,1,.28-.35,7.69,7.69,0,0,1,2.53-.12,1.51,1.51,0,0,1,1.43,1.54c0,.42,0,.85,0,1.27Zm0,7.54v1.76c0,1.12.06,1.18,1.19,1.34a2.26,2.26,0,0,0,2.68-1.77,5.14,5.14,0,0,0,0-2.83,2.25,2.25,0,0,0-.84-1.21,3,3,0,0,0-2.88-.05c-.14.07-.11.19-.11.31Z",
    transform: "translate(-5.59 -154.18)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M147.84,347.45a8.22,8.22,0,0,1-4-.86A5.77,5.77,0,0,1,140.8,342a7.31,7.31,0,0,1,.36-3.76,5.6,5.6,0,0,1,4.78-3.59,6.55,6.55,0,0,1,4.61.91A4.89,4.89,0,0,1,152.9,340a1.62,1.62,0,0,1-1.37,1.61c-.95.22-1.92.31-2.87.46l-3.49.52c-.19,0-.22.08-.14.24a2,2,0,0,0,.91.95,4.94,4.94,0,0,0,3.05.42,6.37,6.37,0,0,0,2.26-.72.3.3,0,0,1,.38.05,1.86,1.86,0,0,1-.24,3.14,6.3,6.3,0,0,1-2.47.69A7.7,7.7,0,0,1,147.84,347.45Zm-3-7.63h0l3.84-.61c.19,0,.24-.12.15-.28a2.26,2.26,0,0,0-.17-.35,2,2,0,0,0-2.38-.83,2.17,2.17,0,0,0-1.63,1.91C144.66,339.73,144.61,339.87,144.8,339.82Z",
    transform: "translate(-5.59 -154.18)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M198.84,341.73c0,1.66,0,3.33,0,5,0,.23,0,.32-.29.36a8.06,8.06,0,0,1-2.4.12,1.61,1.61,0,0,1-1.56-1.72c0-.41,0-.82,0-1.24,0-2.93,0-5.86,0-8.79,0-.25.06-.35.32-.39a7.56,7.56,0,0,1,2.37-.11,1.59,1.59,0,0,1,1.56,1.78c0,1.66,0,3.33,0,5Z",
    transform: "translate(-5.59 -154.18)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M188.3,340.49c0-1.69,0-3.38,0-5.06,0-.22,0-.32.29-.36a9,9,0,0,1,2.07-.16,1.71,1.71,0,0,1,1.89,1.95c0,.59,0,1.18,0,1.77q0,4,0,8c0,.31-.09.42-.4.47a8.66,8.66,0,0,1-2.33.1,1.55,1.55,0,0,1-1.51-1.65c0-1.69,0-3.38,0-5.06Z",
    transform: "translate(-5.59 -154.18)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M188.1,331.58a2.17,2.17,0,0,1,2.32-2.23,2.24,2.24,0,1,1-2.32,2.23Z",
    transform: "translate(-5.59 -154.18)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M196.74,329.35a2.24,2.24,0,1,1-2.35,2.21A2.18,2.18,0,0,1,196.74,329.35Z",
    transform: "translate(-5.59 -154.18)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M125.47,335.29c-.09-.59-.17-1.18-.27-1.77a1.76,1.76,0,0,0-1.3-1.51,3.55,3.55,0,0,0-3.18.6.25.25,0,0,0-.14.27c.1.76.17,1.53.33,2.28l.77,4.26,0,.19.12.19v.07l.06.06.46.72.07.07a6.48,6.48,0,0,0,2.19,1.84,5.46,5.46,0,0,0,2.08.7l-.43-2.87a.23.23,0,0,1,0-.21l0-.25c-.07-.06,0-.13,0-.2l0-.19a.23.23,0,0,1,0-.21v-.12Z",
    transform: "translate(-5.59 -154.18)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M121.7,339.61l.12.19h-.07A.19.19,0,0,1,121.7,339.61Z",
    transform: "translate(-5.59 -154.18)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M126.12,339.54a.23.23,0,0,1,0-.21A.25.25,0,0,1,126.12,339.54Z",
    transform: "translate(-5.59 -154.18)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M126.19,339.93c-.07-.06,0-.13,0-.2A.24.24,0,0,1,126.19,339.93Z",
    transform: "translate(-5.59 -154.18)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M126.25,340.39a.23.23,0,0,1,0-.21A.25.25,0,0,1,126.25,340.39Z",
    transform: "translate(-5.59 -154.18)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M121.82,339.87l.06.06Z",
    transform: "translate(-5.59 -154.18)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M122.34,340.65l.07.07Z",
    transform: "translate(-5.59 -154.18)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneric3);
export default __webpack_public_path__ + "static/media/generic-3.6607ec52abbd14d5e57b163c9984caee.svg";
export { ForwardRef as ReactComponent };